<div [ngSwitch]="field?.appearance">
  <relation-checkbox *ngSwitchCase="'checkbox'" [field]="field" [formGroup]="formGroup"></relation-checkbox>
  <relation-radio *ngSwitchCase="'radio'" [field]="field" [formGroup]="formGroup"></relation-radio>
  <relation-combobox *ngSwitchDefault [field]="field" [formGroup]="formGroup"></relation-combobox>
</div>
